require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-dynamics-365-in-charities-and-not-for-profits.json") })
        }
      }, "path---blog-dynamics-365-in-charities-and-not-for-profits");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-dynamics-365-in-charities-and-not-for-profits!./.cache/json/blog-dynamics-365-in-charities-and-not-for-profits.json
// module id = 822
// module chunks = 231608221292675